import { gql } from '@apollo/client';

export const GET_REASON_FOR_EXITS_BY_GROUP = gql`
  query getReasonForExitsByGroup($input: ReasonForExitGroupInput!) {
    reasonForExitsByGroup: getReasonForExitsByGroup(input: $input) {
      id
      name
    }
  }
`;
